import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamEmailSignatureEmptyState = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '60px 20px',
                textAlign: 'center'
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    fontSize: '1.2rem',
                    color: '#4f4f4f',
                    marginBottom: 2
                }}
            >
                No Email Signature Templates
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: '#757575',
                    fontSize: '0.875rem',
                    lineHeight: 1.6,
                    maxWidth: '600px',
                    marginBottom: 4
                }}
            >
                Create email signature templates to empower your team's communication and ensure
                branding consistency across all email interactions.
            </Typography>
        </Box>
    );
};

export default TeamEmailSignatureEmptyState;

